import { c7Api } from './c7Api';

export interface UploadVideo {
    title: string;
    url: string;
    published_at: string;
    tags: string;
    thumbnail: string;
}

class Videos {
    
    private static videosInstance: Videos;
    private baseUrl:string = "api/videos"

    private constructor() { }

    public static GetInstance(): Videos {
        if(!Videos.videosInstance){
            Videos.videosInstance = new Videos();
        }
        return Videos.videosInstance;
    }

    public async GetVideosByYear(year: string): Promise<UploadVideo []>{
        return await c7Api.get(`${this.baseUrl}/year/${year}`)
    }

    public async GetVideosByFilterText(filter: string): Promise<UploadVideo []>{
        return await c7Api.get(`${this.baseUrl}/search/${filter}`)
    }

    public async GetVideoFromYoutubeID(idVideo: string): Promise<UploadVideo []>{
        return await c7Api.get(`${this.baseUrl}/yt/${idVideo}`)
    }

    public async GetLastVideoUploaded(): Promise<any> {    
         return await c7Api.get("api/videos_new");
    }

    public async UploadVideo(data:UploadVideo): Promise<any> {    
        return await c7Api.post(this.baseUrl, data);
    }
    
    public GetYouTubeVideoIdFromUrl(url: string): string  {
        const regex = /(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : "error";
      }
}

  export const videosLogic = Videos.GetInstance();